var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:[
        {
            'form-row': _vm.horizontal,
        } ]},[(_vm.label)?_c('label',{class:[
            { 'col-form-label': _vm.horizontal },
            _vm.horizontal ? _vm.class_label : '',
            _vm.size == 'sm' ? 'col-form-label-sm' : '' ]},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{class:[
            _vm.horizontal ? _vm.class_input : '',
            _vm.size == 'sm' ? 'input-group-sm' : '' ]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                _vm.valueComponent
            ),expression:"\n                valueComponent\n            "}],class:['w-100'],attrs:{"min":_vm.min,"max":_vm.max,"step":_vm.step,"type":"range","horizontal":_vm.inputHorizontal},domProps:{"value":(
                _vm.valueComponent
            )},on:{"__r":function($event){_vm.valueComponent
            =$event.target.value}}}),(_vm.isValid == false)?_c('div',{staticClass:"invalid-feedback"},[_vm._v(" "+_vm._s(_vm.invalidFeedback)+" ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }